var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCloseOld(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 15.642 15.642"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.882 7.821l6.541-6.541A.75.75 0 1014.362.219L7.821 6.76 1.28.22A.75.75 0 10.219 1.281L6.76 7.822l-6.54 6.54a.75.75 0 001.06 1.061l6.541-6.541 6.541 6.541a.75.75 0 101.06-1.061l-6.54-6.541z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9Im5vbmUiIHZpZXdCb3g9IjAgMCAxNS42NDIgMTUuNjQyIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik04Ljg4MiA3LjgyMWw2LjU0MS02LjU0MUEuNzUuNzUgMCAxIDAgMTQuMzYyLjIxOUw3LjgyMSA2Ljc2IDEuMjguMjJBLjc1Ljc1IDAgMSAwIC4yMTkgMS4yODFMNi43NiA3LjgyMmwtNi41NCA2LjU0YS43NS43NSAwIDAgMCAxLjA2IDEuMDYxbDYuNTQxLTYuNTQxIDYuNTQxIDYuNTQxYS43NS43NSAwIDEgMCAxLjA2LTEuMDYxbC02LjU0LTYuNTQxeiIvPjwvc3ZnPg==";
export { SvgCloseOld as ReactComponent };